<script setup>
/** 候补者状态徽章。枚举值即 i18n 键（`waitlist.status.*` / `waitlist.invite.*`），不做名字映射。 */
import { computed } from 'vue'
import { Badge } from '@drama/ui'
import { useI18n } from 'vue-i18n'

const VARIANTS = {
  status: {
    joined: 'neutral',
    invite_pending: 'warning',
    invited: 'info',
    registered: 'success',
    rejected: 'danger',
  },
  invite: {
    none: 'neutral',
    pending: 'warning',
    sent: 'info',
    failed: 'danger',
    expired: 'warning',
    claimed: 'success',
    closed: 'neutral',
  },
}

const props = defineProps({
  /** @type {import('vue').PropType<'status'|'invite'>} */
  kind: { type: String, default: 'status' },
  value: { type: String, required: true },
  entryId: { type: [Number, String], default: '' },
})

const { t } = useI18n()

const variant = computed(() => {
  const tone = VARIANTS[props.kind][props.value]
  if (tone === undefined) throw new Error(`Unhandled ${props.kind}: ${props.value}, id: ${props.entryId}`)
  return tone
})
</script>

<template>
  <Badge :variant="variant" size="sm">
    {{ t(`visualGameAdmin.waitlist.${kind}.${value}`) }}
  </Badge>
</template>
